import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import BusinessDetail from "@/pages/BusinessDetail";
import Places from "@/pages/Places";
import Newsletter from "@/pages/Newsletter";
import ClaimVerify from "@/pages/ClaimVerify";
import CityLanding from "@/pages/CityLanding";
import Admin from "@/pages/Admin";
import NewsletterReview from "@/pages/NewsletterReview";
import Login from "@/pages/Login";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="py-24 text-center text-muted-foreground">Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/explorar" element={<Explore />} />
              <Route path="/negocio/:id" element={<BusinessDetail />} />
              <Route path="/lugares" element={<Places />} />
              <Route path="/directorio/:citySlug" element={<CityLanding />} />
              <Route path="/directorio/:citySlug/:categorySlug" element={<CityLanding />} />
              <Route path="/newsletter" element={<Newsletter />} />
              <Route path="/reclamar/verificar" element={<ClaimVerify />} />
              <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
              <Route path="/admin/newsletter/:id" element={<RequireAdmin><NewsletterReview /></RequireAdmin>} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
